<script lang="ts">
	import { run } from "svelte/legacy"

	import { DataHandlerDevice, DataHandlerSnapshot, DeviceGroup } from "luxedo-data"
	import { Responsive } from "responsive"

	interface Props {
		selectedSnapshotId: number
		selectedDeviceId: number
	}

	let { selectedSnapshotId, selectedDeviceId }: Props = $props()

	let resX: number = $state()
	let resY: number = $state()

	let isMobile = $derived(Responsive.isMobile)

	function updateResolution() {
		const device = DataHandlerDevice.get(selectedDeviceId)
		const snapshot = DataHandlerSnapshot.get(selectedSnapshotId)

		if (device instanceof DeviceGroup || snapshot === undefined) {
			resX = device.resX
			resY = device.resY
		} else {
			resX = snapshot.resolution.w
			resY = snapshot.resolution.h
		}
	}

	run(() => {
		;(selectedSnapshotId || selectedDeviceId) && updateResolution()
	})
</script>

<div class="flex-column" class:isMobile>
	<h3 class="upload-step">Create and decorate your project</h3>
	<p>
		Using your choice of video editing software, create a new project with the resolution of your
		device
		<span class="highlight">({resX ?? "0"}x{resY ?? "0"})</span>. Import your downloaded snapshot
		and set it as the bottom layer.
	</p>
	<p>
		Mask out your projection space and decorate your scene using your snapshot as a reference. Once
		you are satisfied with your project, move on to the next step.
	</p>
</div>

<style>
	p {
		margin: 1rem 0 0 0;
		color: var(--color-text);
	}

	.highlight {
		color: var(--color-main);
	}
</style>
